import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>ஆன்மீகம் - உள் அடக்கம்</h1>
<div class="mydiv">
  ஆன்மீகம்,&nbsp; திவ்யதேசங்கள், திவ்ய ப்ரபந்தங்கள், வைதீகம்,
    ஜோதிடம், தர்ம சாஸ்திரம் போன்றவற்றில் தெளிவை ஏற்படுத்தக்கூடிய கட்டுரைகள் இங்கு
    ப்ரசுரிக்கப்படும். அன்பர்கள் தங்கள் சொந்தக் கட்டுரையையோ, அல்லது தாங்கள் மிகவும்
    ரசித்த, அனைவரும் அறியவேண்டிய தகவல்கள் அடங்கிய கட்டுரைகளை எந்த வடிவில் அனுப்பி வைத்தாலும்
    இங்கே ப்ரசுரிக்கப்படும்.
</div>`;

const AanmikamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="நுழைவாயில் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default AanmikamPage;
